import { P as PaymentMethodsEnum } from '../subscriptionPlanModel-de0d0313.js';
import { toFixedPrice, DEFAULT_CURRENCY } from '../currencyService/index.js';
import { DEFAULT_TEAM_SCOPE_ID } from '../constants/index.js';

var getPrice = function getPrice(plan) {
  var _plan$prices$find;
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CURRENCY;
  var initial = arguments.length > 2 ? arguments[2] : undefined;
  var raw = arguments.length > 3 ? arguments[3] : undefined;
  var key = initial ? 'initial_value' : 'value';
  var rawPrice = (plan === null || plan === void 0 || (_plan$prices$find = plan.prices.find(function (p) {
    return p.currency === currency;
  })) === null || _plan$prices$find === void 0 ? void 0 : _plan$prices$find[key]) || (plan === null || plan === void 0 ? void 0 : plan.price[key]) || 0;
  return raw ? rawPrice : toFixedPrice(rawPrice);
};
var getTeamPrice = function getTeamPrice() {
  var seatsCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var plan = arguments.length > 1 ? arguments[1] : undefined;
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CURRENCY;
  var raw = arguments.length > 3 ? arguments[3] : undefined;
  if (!seatsCount) {
    return getPrice(plan, currency, true);
  }
  var initialAdminPrice = getPrice(plan, currency, true, true);
  var initialPrice = getPrice(plan, currency, false, true);
  var teamPrice = initialAdminPrice + initialPrice * (seatsCount - 1);
  return raw ? teamPrice : toFixedPrice(teamPrice);
};
var getDerivedDataFromPlans = function getDerivedDataFromPlans(_ref) {
  var _activePlans$, _activePlans$2;
  var initialFrequency = _ref.frequency,
    currentPlan = _ref.selectedPlan,
    paymentInfo = _ref.paymentInfo,
    activePlans = _ref.activePlans;
  var currency = (activePlans === null || activePlans === void 0 || (_activePlans$ = activePlans[0]) === null || _activePlans$ === void 0 || (_activePlans$ = _activePlans$.price) === null || _activePlans$ === void 0 ? void 0 : _activePlans$.currency) || DEFAULT_CURRENCY;
  var selectedPlan;
  if (paymentInfo !== null && paymentInfo !== void 0 && paymentInfo.subscriptionPlan) {
    selectedPlan = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.subscriptionPlan;
  } else {
    selectedPlan = (activePlans === null || activePlans === void 0 ? void 0 : activePlans.find(function (_ref2) {
      var frequency = _ref2.frequency;
      return frequency === ((currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.frequency) || initialFrequency);
    })) || (activePlans === null || activePlans === void 0 ? void 0 : activePlans[0]);
  }
  var isTeams = (activePlans === null || activePlans === void 0 || (_activePlans$2 = activePlans[0]) === null || _activePlans$2 === void 0 ? void 0 : _activePlans$2.scope_id) === DEFAULT_TEAM_SCOPE_ID;
  return {
    selectedPlan: selectedPlan,
    activePlans: activePlans,
    currency: currency,
    isTeams: isTeams
  };
};
var getPlansByTier = function getPlansByTier(tier) {
  var plans = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return plans.filter(function (plan) {
    return plan.tier_id === tier;
  });
};
var getPlanByTierAndFrequency = function getPlanByTierAndFrequency(tier, frequency) {
  var plans = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return plans.find(function (plan) {
    return plan.tier_id === tier && plan.frequency === frequency;
  });
};
var getPaypalAvailability = function getPaypalAvailability(plan) {
  var _plan$providers, _adyenProvider$info;
  var adyenProvider = plan === null || plan === void 0 || (_plan$providers = plan.providers) === null || _plan$providers === void 0 ? void 0 : _plan$providers.find(function (p) {
    return p.provider === PaymentMethodsEnum.Adyen;
  });
  return !!(adyenProvider !== null && adyenProvider !== void 0 && (_adyenProvider$info = adyenProvider.info) !== null && _adyenProvider$info !== void 0 && (_adyenProvider$info = _adyenProvider$info.paymentMethods) !== null && _adyenProvider$info !== void 0 && _adyenProvider$info.find(function (pM) {
    return pM.type === PaymentMethodsEnum.Paypal;
  }));
};
var subscriptionPlansService = {
  getPlanByTierAndFrequency: getPlanByTierAndFrequency,
  getDerivedDataFromPlans: getDerivedDataFromPlans,
  getPaypalAvailability: getPaypalAvailability,
  getPlansByTier: getPlansByTier,
  getTeamPrice: getTeamPrice,
  getPrice: getPrice
};

export { subscriptionPlansService as default, getDerivedDataFromPlans, getPaypalAvailability, getPlanByTierAndFrequency, getPlansByTier, getPrice, getTeamPrice };
//# sourceMappingURL=index.js.map
